<template>
  <div class="home">
    <section class="section is-small" style="padding-bottom: 0">
      <div class="container">
        <div class="content-wrapper" style="margin-top: -260px">
          <div class="columns">
            <div
              v-for="(activeApp, index) in activeApps"
              :key="index"
              class="column is-4"
              :class="getOffset(index)"
            >
              <div
                class="boxicon is-bordered has-text-centered boxicon-home"
                data-animation="fadeInLeft"
              >
                <div class="bicon">
                  <router-link
                    class="link"
                    :to="{ path: activeApp.publicLink }"
                  >
                    <b-icon :icon="activeApp.icon"></b-icon>
                  </router-link>
                </div>
                <h4>{{ $t('viewHome.' + activeApp.name + '-title') }}</h4>

                <p class="has-text-centered" style="margin-bottom: 10px">
                  <a class="link" @click="displayModal(activeApp.name)">
                    <strong>{{ $t(activeApp.name) }}</strong>
                  </a>
                  <span
                    v-html="$t('viewHome.' + activeApp.name + '-description')"
                  >
                  </span>
                </p>
                <div>
                  <nav class="level" style="margin-top: 20px">
                    <div
                      v-for="(keyNumber, index) in Object.keys(
                        keyNumbers[activeApp.name]
                      )"
                      :key="index"
                      class="level-item has-text-centered"
                    >
                      <div>
                        <p class="heading">{{ $t('viewHome.' + keyNumber) }}</p>
                        <p class="title">
                          <template v-if="!isLoading">{{
                            keyNumbers[activeApp.name][keyNumber]
                          }}</template>
                          <b-skeleton
                            height="26px"
                            width="50px"
                            :active="isLoading"
                          />
                        </p>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal :active.sync="display" has-modal-card :width="1000">
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('viewHome.' + activeApp + '-why') }}
          </p>
        </header>
        <section class="modal-card-body">
          <component :is="activeApp + '-why'" />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import carbonService from '@/services/carbonService'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'home',
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      display: false,
      activeApp: null,
      keyNumbers: {
        carbon: {},
        scenario: {},
        transition: {}
      },
      isLoading: false,
      nEntity: 0,
      nGHGI: 0,
      nScenario: 0,
      transition: {
        nActions: 0,
        nEntities: 0
      }
    }
  },
  computed: {
    activeApps: function () {
      return this.coreStore.activeApps
    }
  },
  methods: {
    getOffset: function (index) {
      let offset = 'is-offset-' + (12 - 4 * this.activeApps.length) / 2
      if (index === 0) {
        return { [offset]: true }
      } else {
        return {}
      }
    },
    displayModal: function (app) {
      this.display = true
      this.activeApp = app
    }
  },
  mounted () {
    this.isLoading = true
    this.activeApp = this.activeApps[0].name
    carbonService
      .getCounts()
      .then((data) => {
        this.isLoading = false
        Vue.set(this.keyNumbers, 'carbon', {
          nghgi: data.nGHGI,
          nentities: data.nEntity
        })
        Vue.set(this.keyNumbers, 'scenario', {
          nscenario: data.nScenario
        })
        Vue.set(this.keyNumbers, 'transition', data.transition)
      })
      .catch((erreur) => {
        this.isLoading = false
      })
  },
  beforeMount () {
    for (let app of this.activeApps) {
      Vue.component(
        app.name + '-why',
        // A dynamic import returns a Promise.
        () => import('@/components/' + app.name + '/docs/Why.vue')
      )
    }
  }
}
</script>

<style>
.tabs.is-toggle li.is-active a {
  background-color: rgba(83, 135, 175, 0.1);
  border-color: rgb(66, 128, 176);
}
.b-skeleton-item {
  margin: auto;
}
</style>
